import './main.css';
import MenuPage from './pages/MenuPage';
import GamePage from './pages/GamePage';
import useGameReset from './hooks/useGameReset';
import { useGameStore } from '../store/gameStore';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useShallow } from 'zustand/shallow';
import { Smartphone } from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import classNames from 'classnames';

function Main() {
  // Subscribe to game store
  const { gameActive } = useGameStore(
    useShallow((state) => ({
      gameActive: state.gameActive,
    }))
  );

  const [initialLoad, setInitialLoad] = useState<boolean>(true);

  // Handle reset game at 3am EST
  useGameReset();

  // Handle transition between menu & game page
  useLayoutEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
      return;
    }
    const menuPageElement = document.querySelector('.menu-container');
    const gamePageElement = document.querySelector('.game-container');
    if (gameActive) {
      gamePageElement?.classList.add('fade-in-right');
    } else {
      menuPageElement?.classList.add('fade-in-left');
    }
  }, [gameActive]);

  const [isLandscape, setIsLandscape] = useState(false);

  // Make sure user cannot play in landscape mode
  useEffect(() => {
    const updateOrientation = () => {
      const isNowLandscape = window.innerWidth > window.innerHeight;
      setIsLandscape(isNowLandscape);
    };

    updateOrientation();
    window.addEventListener('resize', updateOrientation);
    window.addEventListener('orientationchange', updateOrientation);

    return () => {
      window.removeEventListener('resize', updateOrientation);
      window.removeEventListener('orientationchange', updateOrientation);
    };
  }, []);

  const isNative = Capacitor.isNativePlatform();

  const mainContainerClass = classNames('main-container', {
    'safe-area-padding': isNative,
  });

  return (
    <div className={mainContainerClass}>
      {isLandscape && (
        <div id="landscape-blocker">
          <div className="flex flex-col items-center gap-4">
            <Smartphone className="phone-icon" />
            <p className="text-xl">Please rotate your device to portrait mode to play.</p>
          </div>
        </div>
      )}
      <div className="app-container">
        {!gameActive && (
          <div className="menu-container">
            <MenuPage />
          </div>
        )}
        {gameActive && (
          <div className="game-container">
            <GamePage />
          </div>
        )}
      </div>
    </div>
  );
}

export default Main;
